import { HTMLProps, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PensionContext } from '../../../../contexts/pension-robot/PensionContext';
import { CurrencyFormGroup } from '../../../general/form-inputs/CurrencyFormGroup';
import { NibudModal } from '../../expenses-overlay/NibudModal';

export const ChangeExpenses: React.FC<{} & HTMLProps<HTMLDivElement>> = () => {
    const { t } = useTranslation('pension');
    const {
        parameters: { expensesInfo },
        actions,
    } = useContext(PensionContext);

    const [showNibudModal, setShowNibudModal] = useState(false);
    return (
        <div className="p-4 border-b">
            <div className="mb-2">
                Verwacht u later niet genoeg inkomen te hebben om uw uitgaven te bekostigen? Dan kunt u ook een
                aanpassing doen in uw uitgaven.
            </div>
            <CurrencyFormGroup
                value={expensesInfo?.goal}
                button={{
                    onClick: () => {
                        setShowNibudModal(true);
                    },
                    label: t('pension-cocktail-fill-screen-expenses-goal-nibud-recalculate'),
                }}
                className="mb-8 w-full"
                onChange={(cents) => {
                    actions.setParameters({ expensesInfo: { goal: cents } });
                }}
                currencyInputProps={{
                    placeholder: `€ ${t('pension-cocktail-fill-screen-expenses-goal-placeholder')}`,
                }}
            />
            <NibudModal
                isShown={showNibudModal}
                onClose={() => {
                    setShowNibudModal(false);
                }}
            />
        </div>
    );
};
